import React, { useId, useRef, useEffect } from 'react';
import { usePropState } from '@anton.bobrov/react-hooks';
import { ExpandContent } from '@anton.bobrov/react-components';
import cx from 'classnames';
import styles from './index.module.scss.js';

const ContentCollection = ({
  className,
  style,
  isExpanded: isExpandedProp,
  name,
  node
}) => {
  const id = useId();
  const listRef = useRef(null);
  const [isExpanded, setIsExpanded] = usePropState(isExpandedProp);
  useEffect(() => {
    setIsExpanded(true);
  }, []);
  return /* @__PURE__ */ React.createElement("div", { className: cx(styles.box, className), style }, /* @__PURE__ */ React.createElement("div", { className: styles.title }, name), /* @__PURE__ */ React.createElement(
    ExpandContent,
    {
      className: styles.expand,
      isActive: isExpanded,
      duration: 750,
      isContentRendered: false,
      hasAlpha: false
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: styles.list,
        ref: listRef,
        id,
        "aria-hidden": !isExpanded
      },
      /* @__PURE__ */ React.createElement("div", { className: "node" }, node)
    )
  ));
};
ContentCollection.displayName = "Layout.ContentCollection";

export { ContentCollection };
//# sourceMappingURL=index.js.map
